import React, { useState, useEffect } from "react";
import API_BASE_URL from "../../../config/api";
import { utils, writeFile } from "xlsx";
import AOS from "aos";
import "aos/dist/aos.css";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../../context/AuthContext";
import axios from "axios";
import { FaDownload, FaRegSmileBeam, FaFolderOpen, FaUserCircle, FaExternalLinkAlt, FaGithub, FaCheck, FaTimes, FaPencilAlt, FaFileAlt, FaCalendarAlt, FaStar, FaSave } from "react-icons/fa";

function GuideProgressContainer() {
    const navigate = useNavigate();
    const { user, isAuthenticated, activeRole } = useAuth();
    const [currentTable, setCurrentTable] = useState(1);
    const [data, setData] = useState([
        [
            { period: "Jan. First fortnight", task: "", comment: "", signature: "" },
            { period: "Jan. Second fortnight", task: "", comment: "", signature: "" },
            { period: "Feb. First fortnight", task: "", comment: "", signature: "" },
            { period: "Feb. Second fortnight", task: "", comment: "", signature: "" },
            { period: "March First fortnight", task: "", comment: "", signature: "" },
            { period: "March Second fortnight", task: "", comment: "", signature: "" },
            { period: "April First fortnight", task: "", comment: "", signature: "" },
            { period: "April Second fortnight", task: "", comment: "", signature: "" },
            { period: "May First fortnight", task: "", comment: "", signature: "" },
            { period: "May Second fortnight", task: "", comment: "", signature: "" },
        ],
        [
            { period: "June First fortnight", task: "", comment: "", signature: "" },
            { period: "June Second fortnight", task: "", comment: "", signature: "" },
            { period: "July First fortnight", task: "", comment: "", signature: "" },
            { period: "July Second fortnight", task: "", comment: "", signature: "" },
            { period: "August First fortnight", task: "", comment: "", signature: "" },
            { period: "August Second fortnight", task: "", comment: "", signature: "" },
            { period: "Sept. First fortnight", task: "", comment: "", signature: "" },
            { period: "Sept. Second fortnight", task: "", comment: "", signature: "" },
            { period: "Oct. First fortnight", task: "", comment: "", signature: "" },
            { period: "Oct. Second fortnight", task: "", comment: "", signature: "" },
            { period: "Nov. First fortnight", task: "", comment: "", signature: "" },
        ],
    ]);

    const [projects, setProjects] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [projectId, setProjectId] = useState(null);
    const [isSaving, setIsSaving] = useState(false);
    const [resources, setResources] = useState({
        githubLink: "",
        resources: "",
    });
    const [marks, setMarks] = useState({
        sem6: 0,
        sem7: 0,
        totalMarks: 100,
    });
    const [isEditingMarks, setIsEditingMarks] = useState(false);
    const [editedMarks, setEditedMarks] = useState({
        sem6: 0,
        sem7: 0,
        totalMarks: 100,
    });

    useEffect(() => {
        AOS.init({ duration: 1000 });

        const fetchProjects = async () => {
            try {
                if (!isAuthenticated || !user) {
                    console.error("User not authenticated");
                    navigate("/");
                    return;
                }

                const userEmail = user.email;

                if (!userEmail) {
                    console.error("No email found for user:", user);
                    toast.error("User email not found. Please contact support.");
                    setLoading(false);
                    return;
                }

                // console.log("Fetching projects for guide with email:", userEmail);

                // Updated endpoint to use guide routes
                const response = await axios.get(
                    `${API_BASE_URL}/api/assigned/${user?.email}`,
                    {
                        headers: {
                            Authorization: `Bearer ${user?.token}`,
                        },
                    }
                );

                if (response.status !== 200) {
                    throw new Error("Failed to fetch projects");
                }

                const data = response.data;
                // console.log("Projects response:", data);

                if (!data.success) {
                    throw new Error(data.message || "Failed to fetch projects");
                }

                // If data.data is array, use it directly (as per controller response structure)
                const assignedProjects = Array.isArray(data.data) ? data.data : [];

                if (assignedProjects.length > 0) {
                    setProjects(assignedProjects);
                    setProjectId(assignedProjects[0]._id);
                    fetchProgressData(assignedProjects[0]._id);
                } else {
                    setError("No assigned projects found.");
                    setLoading(false);
                }
            } catch (err) {
                console.error("Error in fetchProjects:", err);
                setError(err.message);
                setLoading(false);

                if (err.response?.status === 401) {
                    toast.error("Session expired. Please login again.");
                    navigate("/");
                }
            }
        };

        if (isAuthenticated) {
            fetchProjects();
        } else {
            setLoading(false);
        }
    }, [isAuthenticated, user, navigate]);

    const fetchProgressData = async (id) => {
        try {
            setLoading(true);
            const response = await axios.get(
                `${API_BASE_URL}/api/progress/${id}`
            );

            if (response.status !== 200) {
                throw new Error("Failed to fetch progress data");
            }

            const result = response.data;
            if (result.success && result.data) {
                const progressData = result.data;
                const sem6Data =
                    progressData.semesters.find((s) => s.semester === 6)
                        ?.entries || data[0];
                const sem7Data =
                    progressData.semesters.find((s) => s.semester === 7)
                        ?.entries || data[1];
                setData([sem6Data, sem7Data]);

                setResources({
                    githubLink: progressData.githubLink || "",
                    resources: progressData.resources || "",
                });

                if (progressData.marks) {
                    const fixedMarks = { ...progressData.marks, totalMarks: 100 };
                    setMarks(fixedMarks);
                    setEditedMarks(fixedMarks);
                }

                if (result.project) {
                    setProjects((prev) => {
                        const updatedProjects = [...prev];
                        const projectIndex = updatedProjects.findIndex(p => p._id === id);
                        if (projectIndex !== -1) {
                            updatedProjects[projectIndex] = {
                                ...updatedProjects[projectIndex],
                                teamMembers: result.project.teamMembers,
                                objectives: result.project.objectives,
                            };
                        }
                        return updatedProjects;
                    });
                }
            }
            setLoading(false);
        } catch (err) {
            console.error("Error fetching progress data:", err);
            setLoading(false);

            if (err.response?.status === 401) {
                toast.error("Session expired. Please login again.");
                navigate("/");
            }
        }
    };

    const handleInputChange = (tableIndex, rowIndex, field, value) => {
        // Guides only edit comments
        if (field === 'task') return;

        const newData = [...data];
        newData[tableIndex][rowIndex][field] = value;
        setData(newData);
    };

    const handleSaveProgress = () => {
        const semester = currentTable === 1 ? 6 : 7;
        const entries = data[currentTable - 1];
        saveFortnightEntries(semester, entries);
    };

    const saveFortnightEntries = async (semester, entries) => {
        if (!projectId) return;
        try {
            setIsSaving(true);
            const response = await axios.put(
                `${API_BASE_URL}/api/progress/${projectId}/entries`,
                {
                    semester,
                    entries,
                }
            );

            if (response.status !== 200) {
                throw new Error("Failed to update progress entries");
            }
            toast.success("Progress saved", { autoClose: 2000 });
        } catch (err) {
            console.error("Error saving progress data:", err);
            toast.error("Failed to save progress");

            if (err.response?.status === 401) {
                toast.error("Session expired. Please login again.");
                navigate("/");
            }
        } finally {
            setIsSaving(false);
        }
    };

    const handleDownloadReport = () => {
        try {
            const wb = utils.book_new();
            const sem6Headers = [
                ["Fortnight Period", "Task", "Comment", "Signature"],
            ];
            const sem6Data = data[0].map((row) => [
                row.period,
                row.task,
                row.comment,
                row.signature,
            ]);
            const sem6Worksheet = utils.aoa_to_sheet([
                ...sem6Headers,
                ...sem6Data,
            ]);
            const sem7Headers = [
                ["Fortnight Period", "Task", "Comment", "Signature"],
            ];
            const sem7Data = data[1].map((row) => [
                row.period,
                row.task,
                row.comment,
                row.signature,
            ]);
            const sem7Worksheet = utils.aoa_to_sheet([
                ...sem7Headers,
                ...sem7Data,
            ]);
            utils.book_append_sheet(wb, sem6Worksheet, "Semester 6");
            utils.book_append_sheet(wb, sem7Worksheet, "Semester 7");
            writeFile(
                wb,
                `Project_Progress_Report_${new Date().toISOString().split("T")[0]
                }.xlsx`
            );
            toast.success("Report downloaded successfully");
        } catch (err) {
            console.error("Error generating report:", err);
            toast.error("Failed to download report");
        }
    };



    const selectedProject = projects.find(p => p._id === projectId) || projects[0];

    const viewProjectDetails = () => {
        if (selectedProject && selectedProject._id) {
            navigate(`/project/${selectedProject._id}`);
        } else {
            toast.error("Cannot access project details at this time");
        }
    };

    const handleMarkInputChange = (field, value) => {
        let numValue = parseInt(value) || 0;
        if (numValue > 50) numValue = 50;
        if (numValue < 0) numValue = 0;
        setEditedMarks({ ...editedMarks, [field]: numValue });
    };

    const saveMarks = async () => {
        if (!projectId) return;
        try {
            setIsSaving(true);
            const response = await axios.put(
                `${API_BASE_URL}/api/progress/${projectId}/marks`,
                {
                    marks: editedMarks,
                }
            );

            if (response.status !== 200) {
                throw new Error("Failed to update marks");
            }

            setMarks(editedMarks);
            setIsEditingMarks(false);
            toast.success("Marks updated successfully", { autoClose: 2000 });
        } catch (err) {
            console.error("Error saving marks:", err);
            toast.error("Failed to save marks");

            if (err.response?.status === 401) {
                toast.error("Session expired. Please login again.");
                navigate("/");
            }
        } finally {
            setIsSaving(false);
        }
    };

    const cancelEditMarks = () => {
        setEditedMarks(marks);
        setIsEditingMarks(false);
    };

    const calculateTotal = () => {
        return (editedMarks.sem6 || 0) + (editedMarks.sem7 || 0);
    };

    const calculatePercentage = () => {
        const total = calculateTotal();
        return `${Math.round((total / editedMarks.totalMarks) * 100)}%`;
    };

    return (
        <div className="min-h-screen p-4 md:p-8 font-sans">
            <div
                className="flex flex-col md:flex-row justify-between items-center bg-[#B7202E] rounded-xl p-6 md:p-8 text-white shadow-md mb-8 gap-4"
                data-aos="fade-down"
            >
                <div className="flex-1">
                    <h1 className="text-2xl md:text-3xl font-bold mb-2">Progress Review</h1>
                    <p className="text-sm opacity-80 font-medium">
                        {new Date().toLocaleDateString("en-IN", {
                            weekday: "long",
                            year: "numeric",
                            month: "long",
                            day: "numeric",
                        })}
                    </p>
                </div>
                <div className="flex gap-4">
                    <button
                        className="bg-white/15 hover:bg-white/25 text-white border border-white/30 px-5 py-3 rounded-lg font-semibold flex items-center gap-2 transition-all shadow-sm hover:shadow-lg transform hover:-translate-y-0.5 text-sm"
                        onClick={handleDownloadReport}
                        disabled={loading || !projectId}
                    >
                        <FaDownload /> Download Report
                    </button>
                </div>
            </div>

            <div className="mb-8" data-aos="fade-up">
                <h2 className="text-2xl font-semibold mb-6 text-gray-800 relative pb-3 after:absolute after:bottom-0 after:left-0 after:w-16 after:h-1 after:bg-[#B7202E] after:rounded-full">Project Overview</h2>

                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
                    {loading ? (
                        <div className="col-span-full bg-white rounded-xl p-12 text-center text-gray-500 shadow-sm animate-pulse">
                            <div className="inline-block w-8 h-8 border-4 border-[#b7202e] border-t-transparent rounded-full animate-spin mb-4"></div>
                            <div>Loading project details...</div>
                        </div>
                    ) : error ? (
                        <div className="col-span-full bg-white rounded-xl p-8 border border-red-200 text-center shadow-sm">
                            <div className="text-red-500 text-4xl mb-4 flex justify-center"><FaRegSmileBeam /></div>
                            <h3 className="text-xl font-bold text-gray-800 mb-2">Very soon you will be allocated a project</h3>
                            <p className="text-gray-600">{error}</p>
                        </div>
                    ) : projects.length > 0 ? (
                        <>
                            <div className="col-span-1 md:col-span-2 bg-white rounded-2xl p-6 shadow-sm border-t-4 border-[#B7202E] flex flex-col min-h-[220px]">
                                <h3 className="text-lg font-semibold text-gray-800 mb-4 flex items-center justify-between border-b border-gray-100 pb-3">
                                    <div className="flex items-center gap-2">
                                        <span className="bg-[#B7202E]/10 p-2 rounded-lg text-[#B7202E] flex items-center justify-center w-9 h-9">
                                            <FaFolderOpen className="text-base" />
                                        </span>
                                        Project Details
                                    </div>
                                    {projects.length > 1 && (
                                        <select
                                            className="text-xs bg-gray-50 border border-gray-200 text-gray-700 py-1.5 px-3 rounded-lg outline-none focus:border-[#B7202E] focus:ring-1 focus:ring-[#B7202E] cursor-pointer hover:bg-gray-100 transition-colors"
                                            value={projectId || ""}
                                            onChange={(e) => {
                                                const newId = e.target.value;
                                                setProjectId(newId);
                                                fetchProgressData(newId);
                                            }}
                                        >
                                            {projects.map((proj) => (
                                                <option key={proj._id} value={proj._id}>
                                                    {proj.projectTitle.length > 30 ? proj.projectTitle.substring(0, 30) + '...' : proj.projectTitle}
                                                </option>
                                            ))}
                                        </select>
                                    )}
                                </h3>

                                {selectedProject ? (
                                    <div className="mt-2 flex-grow">
                                        <h4 className="text-xl font-bold text-[#B7202E] mb-4 leading-tight">
                                            {selectedProject.projectTitle}
                                        </h4>

                                        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-5">
                                            <div className="flex flex-col gap-1">
                                                <span className="text-gray-500 text-xs font-semibold uppercase tracking-wider">Category</span>
                                                <span className="text-gray-800 font-medium break-words">
                                                    {selectedProject.category && Object.entries(selectedProject.category)
                                                        .filter(([_, value]) => value === true)
                                                        .map(([key]) => key.charAt(0).toUpperCase() + key.slice(1))
                                                        .join(", ")}
                                                </span>
                                            </div>

                                            <div className="flex flex-col gap-1">
                                                <span className="text-gray-500 text-xs font-semibold uppercase tracking-wider">Status</span>
                                                <div>
                                                    <div className={`inline-block px-3 py-1 rounded-full text-xs font-semibold text-white tracking-wide ${selectedProject.status === 'guide-assigned' ? 'bg-purple-600' : 'bg-gray-500'}`}>
                                                        {selectedProject.status ? selectedProject.status.toUpperCase() : 'UNKNOWN'}
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="flex flex-col gap-1">
                                                <span className="text-gray-500 text-xs font-semibold uppercase tracking-wider">Created Date</span>
                                                <span className="text-gray-800 font-medium">
                                                    {selectedProject.date ? new Date(selectedProject.date).toLocaleDateString("en-IN", {
                                                        day: 'numeric', month: 'numeric', year: 'numeric'
                                                    }) : 'N/A'}
                                                </span>
                                            </div>
                                        </div>

                                        {selectedProject.teamMembers && selectedProject.teamMembers.length > 0 && (
                                            <div className="bg-gray-50 p-4 rounded-xl mb-4 border border-gray-100">
                                                <h5 className="text-sm font-semibold text-gray-700 mb-2 uppercase tracking-wider">Team Members</h5>
                                                <ul className="flex flex-wrap gap-2">
                                                    {selectedProject.teamMembers.map((member, index) => (
                                                        <li key={index} className="flex items-center gap-2 bg-white px-3 py-1.5 rounded-full text-xs font-medium text-gray-700 shadow-sm border border-gray-200">
                                                            <FaUserCircle className="text-[#B7202E] text-sm" /> {member}
                                                        </li>
                                                    ))}
                                                </ul>
                                            </div>
                                        )}

                                        <div>
                                            <button
                                                className="inline-flex items-center gap-2 bg-[#B7202E] text-white px-4 py-2 rounded-lg text-sm font-medium hover:bg-[#961925] transition-all transform hover:-translate-y-0.5 shadow-sm hover:shadow-md"
                                                onClick={viewProjectDetails}
                                            >
                                                <FaExternalLinkAlt /> View Full Details
                                            </button>
                                        </div>
                                    </div>
                                ) : (
                                    <div className="text-center py-10 text-gray-400">
                                        Select a project to view details
                                    </div>
                                )}
                            </div>
                            <div className="flex flex-col gap-4">
                                <div className="bg-white rounded-2xl p-6 shadow-sm border border-gray-100 flex flex-col relative overflow-hidden transition-all duration-300 hover:-translate-y-1 hover:shadow-md h-full">
                                    <h3 className="text-lg font-semibold text-gray-800 mb-4 flex items-center gap-2 border-b border-gray-100 pb-3">
                                        <span className="bg-[#B7202E]/10 p-2 rounded-lg text-[#B7202E] flex items-center justify-center w-9 h-9">
                                            <FaGithub className="text-base" />
                                        </span>
                                        GitHub Repository
                                    </h3>

                                    <div className="flex flex-col flex-grow">
                                        <p className="text-sm text-gray-600 mb-4 flex-grow">
                                            Access the project's source code and track changes.
                                        </p>
                                        {resources.githubLink ? (
                                            <div className="bg-gray-50 p-3 rounded-lg border border-gray-100 mt-auto">
                                                <div className="flex justify-between items-center mb-2">
                                                    <a
                                                        href={resources.githubLink}
                                                        target="_blank"
                                                        rel="noopener noreferrer"
                                                        className="text-[#B7202E] font-medium text-sm hover:underline flex items-center gap-1 truncate max-w-full"
                                                    >
                                                        <FaExternalLinkAlt className="text-xs" /> Open Repo
                                                    </a>
                                                </div>
                                                <div className="text-xs text-gray-400 truncate">
                                                    {resources.githubLink.replace('https://github.com/', '')}
                                                </div>
                                            </div>
                                        ) : (
                                            <div className="flex flex-col items-center justify-center flex-grow text-gray-400 italic bg-gray-50 rounded-lg border border-dashed border-gray-200 p-4">
                                                <FaGithub className="text-3xl mb-2 opacity-20" />
                                                <span>No repository link added yet</span>
                                            </div>
                                        )}
                                    </div>

                                    <h3 className="text-lg font-semibold text-gray-800 mb-4 flex items-center gap-2 border-b border-gray-100 pb-3">
                                        <span className="bg-[#B7202E]/10 p-2 rounded-lg text-[#B7202E] flex items-center justify-center w-9 h-9">
                                            <FaFileAlt className="text-base" />
                                        </span>
                                        Resources (Google Drive)
                                    </h3>

                                    <div className="flex flex-col flex-grow">
                                        <p className="text-sm text-gray-600 mb-4 flex-grow">
                                            Access project resources and documentation.
                                        </p>
                                        {resources.resources ? (
                                            <div className="bg-gray-50 p-3 rounded-lg border border-gray-100 mt-auto">
                                                <div className="flex justify-between items-center mb-2">
                                                    <a
                                                        href={resources.resources}
                                                        target="_blank"
                                                        rel="noopener noreferrer"
                                                        className="text-[#B7202E] font-medium text-sm hover:underline flex items-center gap-1 truncate max-w-full"
                                                    >
                                                        <FaExternalLinkAlt className="text-xs" /> Open Resources
                                                    </a>
                                                </div>
                                                <div className="text-xs text-gray-400 truncate">
                                                    {resources.resources}
                                                </div>
                                            </div>
                                        ) : (
                                            <div className="flex flex-col items-center justify-center flex-grow text-gray-400 italic bg-gray-50 rounded-lg border border-dashed border-gray-200 p-4">
                                                <FaFolderOpen className="text-3xl mb-2 opacity-20" />
                                                <span>No resources link added yet</span>
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </div>

                            {activeRole === "guide" && (
                                <div className="bg-white rounded-2xl p-6 shadow-sm border border-gray-100 flex flex-col relative overflow-hidden transition-all duration-300 hover:-translate-y-1 hover:shadow-md h-full" data-aos="fade-up">
                                    <div className="absolute top-0 left-0 w-full h-1 bg-[#B7202E]"></div>
                                    <h3 className="text-lg font-semibold text-gray-800 mb-4 flex items-center gap-2 border-b border-gray-100 pb-3">
                                        <span className="bg-[#B7202E]/10 p-2 rounded-lg text-[#B7202E] flex items-center justify-center w-9 h-9">
                                            <FaStar className="text-base" />
                                        </span>
                                        Project Evaluation
                                    </h3>
                                    <p className="text-xs text-gray-500 mb-4">
                                        Assign marks for the student project in different semesters
                                    </p>

                                    {isEditingMarks ? (
                                        <div className="flex flex-col gap-3">
                                            <div className="grid grid-cols-2 gap-3">
                                                {[6, 7].map((sem) => (
                                                    <div key={sem} className="flex flex-col gap-1">
                                                        <span className="text-xs font-semibold text-gray-600">Sem {sem}</span>
                                                        <input
                                                            type="number"
                                                            value={editedMarks[`sem${sem}`]}
                                                            onChange={(e) => handleMarkInputChange(`sem${sem}`, e.target.value)}
                                                            min="0"
                                                            max="50"
                                                            className="w-full px-2 py-1.5 rounded-lg border border-gray-200 text-sm focus:border-[#B7202E] focus:ring-1 focus:ring-[#B7202E] outline-none"
                                                        />
                                                    </div>
                                                ))}
                                            </div>

                                            <div className="border-t border-gray-100 my-2"></div>

                                            <div className="flex justify-between items-center bg-gray-50 p-3 rounded-lg">
                                                <div>
                                                    <span className="text-xs font-bold text-gray-600 block">Total Marks:</span>
                                                    <span className="text-lg font-bold text-[#B7202E]">{calculateTotal()} / {editedMarks.totalMarks}</span>
                                                </div>
                                                <div className="text-xl font-bold text-gray-800">{calculatePercentage()}</div>
                                            </div>

                                            <div className="flex gap-2 mt-2">
                                                <button
                                                    className="flex-1 bg-[#B7202E] text-white py-2 rounded-lg text-xs font-semibold hover:bg-[#961925] transition-colors flex items-center justify-center gap-1"
                                                    onClick={saveMarks}
                                                >
                                                    <FaCheck /> Save
                                                </button>
                                                <button
                                                    className="flex-1 bg-gray-100 text-gray-700 py-2 rounded-lg text-xs font-semibold hover:bg-gray-200 transition-colors flex items-center justify-center gap-1"
                                                    onClick={cancelEditMarks}
                                                >
                                                    <FaTimes /> Cancel
                                                </button>
                                            </div>
                                        </div>
                                    ) : (
                                        <div className="flex flex-col gap-4">
                                            <div className="grid grid-cols-2 gap-3">
                                                {[6, 7].map((sem) => (
                                                    <div key={sem} className="flex flex-col gap-1 bg-gray-50 p-2 rounded-lg border border-gray-100">
                                                        <span className="text-[10px] font-semibold text-gray-500 uppercase">Sem {sem}</span>
                                                        <span className="text-lg font-bold text-gray-800">{marks[`sem${sem}`]}</span>
                                                    </div>
                                                ))}
                                            </div>

                                            <div className="flex justify-between items-center bg-[#B7202E]/5 p-3 rounded-lg border border-[#B7202E]/10">
                                                <div>
                                                    <span className="text-xs font-bold text-gray-600 block">Total Marks:</span>
                                                    <span className="text-lg font-bold text-[#B7202E]">{(marks.sem6 || 0) + (marks.sem7 || 0)} / {marks.totalMarks}</span>
                                                </div>
                                                <div className="text-xl font-bold text-gray-800">
                                                    {Math.round((((marks.sem6 || 0) + (marks.sem7 || 0)) / marks.totalMarks) * 100)}%
                                                </div>
                                            </div>

                                            <button
                                                className="w-full bg-[#B7202E] text-white py-2 rounded-lg text-xs font-semibold hover:bg-[#961925] transition-colors flex items-center justify-center gap-1 shadow-sm mt-auto"
                                                onClick={() => setIsEditingMarks(true)}
                                            >
                                                <FaPencilAlt /> Edit Marks
                                            </button>
                                        </div>
                                    )}
                                </div>
                            )}

                            <div className="bg-white rounded-2xl p-6 md:p-8 shadow-sm mb-8 border border-gray-100 md:col-span-2 col-span-1 lg:col-span-4" data-aos="fade-up">
                                <h2 className="text-2xl font-semibold mb-6 text-gray-800 relative pb-3 after:absolute after:bottom-0 after:left-0 after:w-16 after:h-1 after:bg-[#B7202E] after:rounded-full">
                                    Fortnight Progress Checks
                                </h2>

                                <div className="flex flex-wrap gap-4 mb-8">
                                    <button
                                        className={`px-6 py-3 rounded-full font-semibold flex items-center gap-2 transition-all duration-300 ${currentTable === 1 ? "bg-[#B7202E] text-white shadow-md transform scale-105" : "bg-gray-100 text-gray-600 hover:bg-gray-200"}`}
                                        onClick={() => setCurrentTable(1)}
                                    >
                                        <FaCalendarAlt /> Semester 6
                                    </button>
                                    <button
                                        className={`px-6 py-3 rounded-full font-semibold flex items-center gap-2 transition-all duration-300 ${currentTable === 2 ? "bg-[#B7202E] text-white shadow-md transform scale-105" : "bg-gray-100 text-gray-600 hover:bg-gray-200"}`}
                                        onClick={() => setCurrentTable(2)}
                                    >
                                        <FaCalendarAlt /> Semester 7
                                    </button>
                                </div>

                                <div className="bg-white rounded-xl border border-gray-200 overflow-hidden shadow-sm">
                                    <div className="p-6 bg-gray-50 border-b border-gray-200 flex justify-between items-center">
                                        <h3 className="font-bold text-gray-700">Timeline Chart for UG Project Work Completion</h3>
                                        <div className="flex items-center gap-2">
                                            {isSaving && (
                                                <span className="text-xs font-semibold bg-[#B7202E] text-white px-3 py-1 rounded-full animate-pulse flex items-center gap-1">
                                                    <FaSave className="text-xs" /> Saving...
                                                </span>
                                            )}
                                            <button
                                                className="bg-[#B7202E] text-white px-4 py-2 rounded-lg text-sm font-semibold hover:bg-[#961925] transition-colors flex items-center gap-2 shadow-sm"
                                                onClick={handleSaveProgress}
                                                disabled={isSaving}
                                            >
                                                <FaSave /> Save Progress
                                            </button>
                                        </div>
                                    </div>
                                    <div className="overflow-x-auto">
                                        <table className="w-full text-left text-sm text-gray-600">
                                            <thead className="bg-[#B7202E] text-white uppercase font-bold tracking-wider text-xs">
                                                <tr>
                                                    <th className="px-6 py-4 border-b">Fortnight Period</th>
                                                    <th className="px-6 py-4 border-b">Task (to be filled by the project group)</th>
                                                    <th className="px-6 py-4 border-b">Comment of guide about work completed</th>
                                                </tr>
                                            </thead>
                                            <tbody className="divide-y divide-gray-100">
                                                {data[currentTable - 1].map((row, index) => (
                                                    <tr key={index} className="hover:bg-gray-50 transition-colors">
                                                        <td className="px-6 py-4 font-medium text-gray-800 border-r border-gray-100 bg-gray-50/50 w-1/5 whitespace-nowrap">
                                                            {row.period}
                                                        </td>
                                                        <td className="px-6 py-3 border-r border-gray-100 w-2/5">
                                                            <div className="text-gray-800 p-2 bg-gray-50 rounded border border-gray-200/50">
                                                                {row.task || <span className="text-gray-400 italic">No task entered by student</span>}
                                                            </div>
                                                        </td>
                                                        <td className="px-6 py-3 w-2/5">
                                                            <textarea
                                                                value={row.comment}
                                                                placeholder="Enter your comment here..."
                                                                onChange={(e) => handleInputChange(currentTable - 1, index, "comment", e.target.value)}
                                                                className="w-full p-2 rounded border border-gray-200 focus:border-[#B7202E] focus:ring-1 focus:ring-[#B7202E] outline-none bg-blue-50/20 text-sm transition-all resize-y min-h-[60px]"
                                                            />
                                                        </td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </>
                    ) : (
                        <div className="col-span-full bg-yellow-50 rounded-xl p-8 border border-yellow-200 text-center">
                            <h3 className="text-lg font-bold text-yellow-700 mb-2">No Project Found</h3>
                            <p className="text-yellow-600">No approved projects available.</p>
                        </div>
                    )}
                </div>
            </div>


        </div >
    );
}

export default GuideProgressContainer;
